import { TweenLite } from 'gsap'
import {map} from 'src/helpers/MathUtils'

class Arrow {

  constructor(config) {

  	this.visible = false;
    this.tweenObj = {
      alpha: 0,
      active_alpha: 0,
      pulse_clamp: 1
    };

    this.ctx = config.ctx;
    this.lineWidth = config.lineWidth;
    this.pixelRatio = config.pixelRatio;
    this.radius = config.radius;
    this.points = config.points;
    this.padding = config.padding;
    this.progress = config.progress;
    this.height = config.height;
    this.NUM_OF_DOTS = config.NUM_OF_DOTS;
    this.count = 0;
    this.up();
  }

  	draw(i){
    
     	this.ctx.save();
 
		let x = (this.padding + this.radius ) * this.pixelRatio;
		let r = 1.5 * this.pixelRatio;
		let padding = (r + this.padding);
		let availableHeight =(this.height - (this.radius  * 2) - padding);
		let y = ( padding + (availableHeight / this.NUM_OF_DOTS) * i) * this.pixelRatio; 
		this.ctx.beginPath();
		this.ctx.fillStyle = 'rgba(255,255,255,0.6)'; 
		this.ctx.arc(x,y,r,0,2*Math.PI);

		let sin  = Math.sin((i * 0.6) + this.count);
		let pulse = map(sin, -1,1, this.tweenObj.pulse_clamp,1); 
		this.ctx.globalAlpha = (this.tweenObj.alpha * this.tweenObj.active_alpha * pulse); 
		this.ctx.fill();
     	this.ctx.restore(); 

     	this.count += 0.03;
  	}

	active(){
		if(!this.visible){
			TweenLite.to(this.tweenObj, 1, { active_alpha: 1 });
			this.visible = true;
		} 
	}

	inactive(){
		if(this.visible){
			TweenLite.to(this.tweenObj, 0.1, { active_alpha: 0 });
			this.visible = false;
		} 
	}

	show(delay){ 
		TweenLite.to(this.tweenObj, 1, { alpha: 1, delay: delay, ease: 'Quad.easeInOut' }); 
	}

	up(){
		TweenLite.killTweensOf(this.tweenObj);
		TweenLite.to(this.tweenObj, 1, {
            pulse_clamp: 0.2,
            delay: 4,
            onStart: () => { this.count = 0; },
            ease: 'Quad.easeInOut'
        });
	}

	down(){
		TweenLite.killTweensOf(this.tweenObj);
		TweenLite.set(this.tweenObj, {
            pulse_clamp: 1 
        });
		TweenLite.to(this.tweenObj, 1, { alpha: 1, ease: 'Quad.easeInOut' }); 
	}

}

export default Arrow